import React from 'react';
import { OnboardingData } from '../../onboarding.type';
import ImageUpload, { FileUploadType } from '../../../ui/file-upload.ui';
import InputUi, { InputType } from '../../../ui/input.ui';
import TextFieldUi from '../../../ui/text-field.ui';
import SelectUi from '../../../ui/select.ui';
import CityInput from '../../../ui/city-input.ui';
import { UserRole, Gender } from '../../../user/user.type';

import styles from './onboarding-step-user-personal-info.module.css';

const genderOptions = Object.values(Gender);

const genderOptionsUi = genderOptions.map((gender) => ({
  value: gender,
  title: gender,
}));

enum aboutTextPlaceholder {
  Founder = 'My motivation to build a startup is...',
  SoftwareEngineer = 'My motivation to join a startup is...',
};

type OnboardingStepUserPersonalInfoUiProps = {
  profileImagePreview: string | null;
  isUploadingProfileImage: boolean;
  firstName: string;
  lastName: string;
  about: string;
  aboutCount: number;
  role: string;
  gender: string;
  city: string;
  profileImageError: string | undefined;
  lastNameError: string | undefined;
  firstNameError: string | undefined;
  aboutError: string | undefined;
  genderError?: string;
  cityError?: string;
  onUpdateField: (field: keyof OnboardingData, value: string | null) => void;
  onUpdateAbout: (value: string) => void;
  onProfileImageSelect: (file: File | null) => void;
  onProfileImageError: (error: string | null) => void;
}

const OnboardingStepUserPersonalInfoUi = (props: OnboardingStepUserPersonalInfoUiProps) => {
  const {
    profileImagePreview,
    isUploadingProfileImage,
    firstName,
    lastName,
    role,
    about,
    aboutCount,
    gender,
    city,
    profileImageError,
    firstNameError,
    lastNameError,
    aboutError,
    genderError,
    cityError,
    onProfileImageSelect,
    onUpdateField,
    onUpdateAbout,
    onProfileImageError,
  } = props;

  return (
    <>
      <div className={styles.imageWrapper}>
        <ImageUpload
          uploadType={FileUploadType.image}
          currentFile={profileImagePreview}
          isUploading={isUploadingProfileImage}
          onFileChange={onProfileImageSelect}
          onError={onProfileImageError}
          error={profileImageError}
        />
      </div>

      <InputUi
        id={'firstName'}
        type={InputType.text}
        value={firstName}
        placeholder={'First Name'}
        error={firstNameError}
        onChange={(val) => onUpdateField('firstName', val)}
      />

      <InputUi
        id={'lastName'}
        type={InputType.text}
        value={lastName}
        placeholder={'Last Name'}
        error={lastNameError}
        onChange={(val) => onUpdateField('lastName', val)}
      />

      <TextFieldUi
        id={'about'}
        value={about}
        rows={3}
        placeholder={role === UserRole.Founder ? aboutTextPlaceholder.Founder : aboutTextPlaceholder.SoftwareEngineer}
        error={aboutError}
        counter={aboutCount}
        minLength={20}
        maxLength={80}
        onChange={(val) => onUpdateAbout(val)}
      />

      <SelectUi
        key="gender-select"
        id="gender"
        options={genderOptionsUi}
        value={gender || ''}
        placeholder={'Gender'}
        error={genderError}
        onChange={(value) =>
          onUpdateField('gender', value)
        }
      />

      <CityInput
        value={city}
        error={cityError}
        onChange={(value) => onUpdateField('city', value)}
      />
    </>
  );
};

export default OnboardingStepUserPersonalInfoUi;
